import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UigB2BUser } from '../../uig-user/uig-user.model';
import { UigB2BUserAdapter } from './uig-b2b-user.adapter';

@Injectable({
  providedIn: 'root',
})
export class UigB2BUserConnector {
  constructor(protected adapter: UigB2BUserAdapter) {}

  delete(userId: string): Observable<UigB2BUser> {
    return this.adapter.delete(userId);
  }
}
